/* eslint-disable react/no-unknown-property */
import React from "react";
import { RecoilRoot } from "recoil";
import RecoilNexus from "recoil-nexus";
import { Router } from "./navigation/router";
import { ToastContainer } from "react-toastify";
import { QueryClientProvider } from "@tanstack/react-query";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { createRoot } from "react-dom/client";
import queryClient from "./queryClient";
import "./assets/scss/main.scss";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://38d7a7718518057624b9638718322eba@o4507973966561280.ingest.us.sentry.io/4509127659225088"
});

createRoot(document.getElementById("app")!).render(
  <RecoilRoot>
    <QueryClientProvider client={queryClient}>
      <RecoilNexus />
      <Router />
      <ToastContainer />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </RecoilRoot>
);
// render(
//   <RecoilRoot>
//     <QueryClientProvider client={queryClient}>
//       <RecoilNexus />
//       <Router />
//       <ToastContainer />
//       {/* <RouterProvider router={router} /> */}
//       <ReactQueryDevtools initialIsOpen={false} />
//     </QueryClientProvider>
//   </RecoilRoot>,
//   document.getElementById("app") as HTMLElement
// );
